import { BFormDatepicker } from './form-datepicker';
import { pluginFactory } from '../../utils/plugins';
var FormDatepickerPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormDatepicker: BFormDatepicker,
    BDatepicker: BFormDatepicker
  }
});
export { FormDatepickerPlugin, BFormDatepicker };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-datepicker/index.js
// module id = 199
// module chunks = 0